import type { IAppThunk } from "../../app/store";
import { buildAndCopyPipesFromMcBimSpace } from "@multiconsult-group/multiplacer-core";
import { selectHttpGetMcBimStandardSpace } from "../../McBim/httpMcBimStandardSelectors";
import { selectActivePartialMcbimSpace } from "../../McBim/mcbimSelectors";
import { selectHttpRoutingPipeGeometriesFromStandardSpace } from "../../McBim/pipeSystemSelectors";
import { selectProjectNo } from "../designSlice";
import { routingGraphToPixPaths } from "./routingGrahpUti";
import { setUnsavedRoutingItems } from "./unsavedRoutingSlice";

const STANDARD_ROOM_PIPE_ROUTING_SYSTEM_CODE = "STANDARD_ROOM_PIPE_DUCT";

export const thunkBuildRoutingGraphFromStandardRoomPipeGeometries = (
  selectedSystems: string[]
): IAppThunk => {
  return (dispatch, getState) => {
    const state = getState();
    const projectNo = selectProjectNo(state);
    const floorName = state.design.floorAndJob?.floorName;
    const standardSpace = selectHttpGetMcBimStandardSpace(state);
    const activeMcbimSpace = selectActivePartialMcbimSpace(state);
    const routingInputs = selectHttpRoutingPipeGeometriesFromStandardSpace(state);
    const selectedSystemSet = new Set(
      selectedSystems.map((system) => system.trim()).filter(Boolean)
    );

    if (
      !projectNo ||
      !floorName ||
      !standardSpace ||
      !activeMcbimSpace ||
      routingInputs.length === 0 ||
      selectedSystemSet.size === 0
    ) {
      return;
    }

    try {
      const routingGraphs = routingInputs
        .filter((routingInput) => selectedSystemSet.has(routingInput.system))
        .filter((routingInput) => routingInput.mcBimPipeGeometries.length > 0)
        .flatMap((routingInput) =>
          buildAndCopyPipesFromMcBimSpace({
            projectNo,
            floorName,
            roomNumber: routingInput.roomNumber,
            systemCode: STANDARD_ROOM_PIPE_ROUTING_SYSTEM_CODE,
            systemName: routingInput.system,
            mcBimPipeGeometries: routingInput.mcBimPipeGeometries,
            mcBimConnectionGeometries: routingInput.mcBimConnectionGeometries,
            spaceToCopyFrom: standardSpace,
            spaceToCopyTo: activeMcbimSpace,
          })
        );

      const routingPixPaths = routingGraphs.flatMap((routingGraph) =>
        routingGraphToPixPaths(routingGraph)
      );

      dispatch(
        setUnsavedRoutingItems(
          routingGraphs.map((routingGraph, index) => ({
            localId: `std-room-routing:${routingGraph.roomNumber ?? "unknown"}:${routingGraph.systemName ?? routingGraph.systemCode}:${index}`,
            routingGraph,
            createdAtIso: new Date().toISOString(),
          }))
        )
      );

      console.log(
        "thunkBuildRoutingGraphFromStandardRoomPipeGeometries: built routing graphs",
        routingGraphs
      );
      console.log(
        "thunkBuildRoutingGraphFromStandardRoomPipeGeometries: converted pix paths",
        routingPixPaths
      );
    } catch (error) {
      console.error(
        "thunkBuildRoutingGraphFromStandardRoomPipeGeometries: Failed to build routing graph",
        error
      );
    }
  };
};
